import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import '@swc/helpers';
import '../models/adyen/payment-type.js';
import '../models/cart-payment-methods/cart-payment-methods.js';
import '../models/googlePay/types.js';
import '../models/payment/types.js';
import '../models/paypal/context.js';
import '@grandvisionhq/icons';
import { mapExpressPaymentMethods } from '../mappers/express-payment-methods.js';
import { errorsMapping } from '../mappers/errors-mapping.js';
import '../operations/queries/get-cart-payment-methods.js';
import { GET_CART_EXPRESS_PAYMENT_METHODS } from '../operations/queries/get-cart-express-payment-methods.js';
import '../operations/queries/get-payment-status-by-token.js';

const useGetCartExpressPaymentMethods = ()=>{
    const [getCartExpressPaymentMethods, { called , loading , data , error: error1  }] = useLazyQuery(GET_CART_EXPRESS_PAYMENT_METHODS, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
        }
    });
    const getCartExpressPaymentMethodsMemoized = React.useCallback((cartId)=>{
        if (cartId) {
            getCartExpressPaymentMethods({
                variables: {
                    cartId
                }
            });
        }
    }, [
        getCartExpressPaymentMethods
    ]);
    return [
        getCartExpressPaymentMethodsMemoized,
        {
            data: mapExpressPaymentMethods(data === null || data === void 0 ? void 0 : data.cartExpressPaymentMethods),
            called,
            error: error1,
            loading
        }, 
    ];
};

export { useGetCartExpressPaymentMethods };
//# sourceMappingURL=use-get-cart-express-payment-methods.js.map
